export {default as Edge365MainScreen} from './Edge365MainScreen.connect';
